import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import dashboardReducer from './slices/dashboardSlice';
import jobsReducer from './slices/jobsSlice';
import usersReducer from './slices/usersSlice';
import employersReducer from './slices/employersSlice';
import applicationsReducer from './slices/applicationsSlice';
import conversationsReducer from './slices/conversationsSlice';
import settingsReducer from './slices/settingsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboard: dashboardReducer,
    jobs: jobsReducer,
    users: usersReducer,
    employers: employersReducer,
    applications: applicationsReducer,
    conversations: conversationsReducer,
    settings: settingsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['auth/loginStaff/fulfilled'],
      },
    }),
});

export default store;
